import React, { useEffect, useRef } from 'react';
import { Marker } from 'react-leaflet';
import 'leaflet-rotatedmarker';

// Marker live a key stabile: aggiorna posizione/rotazione senza remount a ogni PKT_NUM.
export default function LiveMarker({
  position,
  icon,
  rotationAngle,
  eventHandlers,
  children,
  zIndexOffset,
  onMarkerRef,
}) {
  const markerRef = useRef(null);

  const setMarkerRef = (instance) => {
    markerRef.current = instance;
    if (typeof onMarkerRef === 'function') {
      onMarkerRef(instance);
    }
  };

  useEffect(() => {
    const markerInstance = markerRef.current;
    if (!markerInstance) {
      return;
    }
    if (rotationAngle != null && typeof markerInstance.setRotationAngle === 'function') {
      markerInstance.setRotationAngle(rotationAngle);
    }
    if (typeof markerInstance.setRotationOrigin === 'function') {
      markerInstance.setRotationOrigin('center center');
    }
    // Dopo setLatLng Leaflet ricalcola lo z-index: reimposta l'offset così il live resta sopra la traccia.
    if (zIndexOffset != null && typeof markerInstance.setZIndexOffset === 'function') {
      markerInstance.setZIndexOffset(zIndexOffset);
    }
  }, [rotationAngle, position, icon, zIndexOffset]);

  return (
    <Marker
      ref={setMarkerRef}
      position={position}
      icon={icon}
      rotationAngle={rotationAngle}
      eventHandlers={eventHandlers}
      zIndexOffset={zIndexOffset}
    >
      {children}
    </Marker>
  );
}
